"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKeyVisualProperty = exports.keyVisualPropertyDefinition = void 0;
exports.keyVisualPropertyDefinition = {
    name: 'key-visual',
    type: 'asset',
    constraints: [
        {
            name: 'stencils',
            argument: ['image'],
        },
    ],
    multiple: false,
    view: {
        label: 'Key visual',
        style: 'media-preview',
    },
};
const isKeyVisualProperty = (prop) => {
    return prop.name === exports.keyVisualPropertyDefinition.name;
};
exports.isKeyVisualProperty = isKeyVisualProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5LXZpc3VhbC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2tleS12aXN1YWwucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxJQUFJLEVBQUUsWUFBWTtJQUNsQixJQUFJLEVBQUUsT0FBTztJQUNiLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsT0FBTyxDQUFDO1NBQ3BCO0tBQ0Y7SUFDRCxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxZQUFZO1FBQ25CLEtBQUssRUFBRSxlQUFlO0tBQ3ZCO0NBQzhCLENBQUE7QUFJMUIsTUFBTSxtQkFBbUIsR0FBRyxDQUFDLElBQWtCLEVBQTZCLEVBQUU7SUFDbkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLG1DQUEyQixDQUFDLElBQUksQ0FBQTtBQUN2RCxDQUFDLENBQUE7QUFGWSxRQUFBLG1CQUFtQix1QkFFL0IifQ==